import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Typography,
} from '@mui/material';
import persianJs from 'persianjs';
import { useStyles } from './Style';
import CardsServices from '../../../Cards/services';
import { useNavigate } from 'react-router-dom';
import { deleteNullValueFromObj } from 'utility';
import Services from '../../services/ImprestServices';
import useCustomHook from '../../hooks';
import { useCurrencyUnit } from 'hooks';
import { PriceLabel } from 'components';

const WithdrawalDialog = (props) => {
  const {
    onClose,
    selectedValue,
    userId,
    branchId,
    open,
    method,
    saveAccountNumber = false,
  } = props;

  const currencyText = useCurrencyUnit(false);
  const classes = useStyles();
  const { isLoadingBtn, setIsLoadingBtn } = useCustomHook();
  const navigate = useNavigate();
  const pathname = navigate.location.pathname;
  const handleClose = () => {
    onClose();
  };

  const handleWithdraw = async () => {
    setIsLoadingBtn(true);
    try {
      let data = {
        amount: selectedValue.amount,
        firstName: selectedValue.firstName,
        lastName: selectedValue.lastName,
        toolCode: selectedValue.toolCode,
        toolId: selectedValue.toolId.value ?? selectedValue?.toolId,
        uniqueId: selectedValue.uniqueId,
        captchaId: selectedValue?.captchaId,
        captchaAnswer: selectedValue?.captchaAnswer,
        description: selectedValue?.description,
        paymentId: selectedValue?.paymentId.trim() || null,
      };
      !data['paymentId'] && delete data['paymentId'];
      if (saveAccountNumber) {
        await postItem(
          selectedValue?.toolId?.value ?? selectedValue?.toolId,
          selectedValue?.numberName,
          selectedValue.toolCode.toLowerCase().includes('card') ? 'card' : 'sheba',
        );
      }
      if (method === 'wallet') {
        data['wallet'] = 'PODLAND_WALLET';
        deleteNullValueFromObj(data);
        await Services.SettelmentByToolUser(userId, data);
        setIsLoadingBtn(false);

        navigate(pathname.includes('Imprest') ? '/Imprest' : '/Accounts');
        onClose();
      } else {
        data['guildCode'] = selectedValue.guildCode;
        deleteNullValueFromObj(data);
        await Services.SettelmentByTool(branchId, data);
        setIsLoadingBtn(false);

        navigate(pathname.includes('Imprest') ? '/Imprest' : '/Accounts');
        onClose();
      }
    } catch (e) {
      setIsLoadingBtn(false);
      onClose();
    }
  };

  const postItem = async (accountNumber, accountName, type = 'card') => {
    const body =
      type === 'card'
        ? {
            cardNumber: persianJs(accountNumber).toEnglishNumber().toString(),
            name: accountName,
            cvv2: null,
            expiryMonth: null,
            expiryYear: null,
            order: null,
            tag: [],
          }
        : {
            sheba: accountNumber,
            name: accountName,
          };

    type === 'card' ? await CardsServices.postCard(body) : await CardsServices.postSheba(body);
  };

  return (
    <>
      <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" fullWidth open={open}>
        <DialogTitle className={classes.title}>توجه</DialogTitle>

        <DialogContent className={classes.dialog}>
          <Typography variant="body1" gutterBottom style={{ marginTop: '20px' }}>
            اطلاعات زیر را تایید و از درخواست خود اطمینان دارید :
          </Typography>
          <div className="">
            مبلغ قابل برداشت :<PriceLabel amount={selectedValue.amount} currency={currencyText}/> 
          </div>
          <div className="">
            {selectedValue.toolCode === 'SETTLEMENT_TOOL_CARD'
              ? 'شماره کارت مقصد'
              : 'شماره شبای مقصد'}
            : {selectedValue?.toolId?.label ?? selectedValue?.toolId}
          </div>
          <div className="">
            نام و نام خانوادگی : {selectedValue.firstName + ' ' + selectedValue.lastName}
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleWithdraw}
            disabled={isLoadingBtn}
            variant="contained"
            color="primary"
          >
            بلی
            {isLoadingBtn && <CircularProgress size={24} />}
          </Button>
          <Button onClick={handleClose} variant="contained">
            خیر
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default WithdrawalDialog;
